import { xhrRequest, displayMoreFlag } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['dummyCard'];

  connect() {
    this.setSidebarContent();
  }

  setSidebarContent() {
    this.dummyCardTarget.innerHTML = App.spinner();
    xhrRequest(this.url, 'get').then(({ data }) => {
      App.Helpers.replaceElement(this.dummyCardTarget, data);
      displayMoreFlag(document.querySelectorAll('.scrollable-starred-items-container')); // Possibly show the "more" signifier
    });
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get('url');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/projects/project-sidebar-controller.js